import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatLabel } from '@angular/material';
import { LoginService } from '../services/login.service';
import { UnapprovedSources } from '../unapproved-source-interface';
import { Observable } from 'rxjs';
import * as XLSX from 'xlsx';
import { Router } from '@angular/router';

interface MyArrayType {
  company: string;
  sites: string;
}

var arr: MyArrayType[] = [];



@Component({
  selector: 'app-unapprovedsources',
  templateUrl: './unapprovedsources.component.html',
  styleUrls: ['./unapprovedsources.component.css']
})
export class UnapprovedsourcesComponent implements OnInit {

  displayedColumns: string[] = ['company', 'sites'];


  dataSource = new MatTableDataSource();

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(@Inject(HttpClient) http: HttpClient, @Inject('BASE_URL') baseUrl: string, @Inject(Router) _router: Router) {
    this.baseURL = baseUrl;
    this.http = http;
    this.router = _router;
  }

  authenticated: string = "";
  router: Router;
  navigation: any;
  http: HttpClient;
  baseURL = '';


  ngOnInit() {



  }

  ngAfterViewInit() {

    this.authenticated = sessionStorage.getItem('intcontId')

    if (this.authenticated == "0") {
      this.router.navigate(['/', 'login']);
    } else {

      arr = [];
      this.http.get(this.baseURL + 'api/UnapprovedSources/GetUnapprovedSource').subscribe(data => {
        var keys = Object.keys(data);
        var len = keys.length;

        for (var i = 0; i <= len - 1; i++) {
          var comp = data[i]["company"];
          var site = data[i]["sites"];

          if (comp != "") {
            var dataArray: MyArrayType = { company: comp, sites: site };
          }
          else {
            var dataArray: MyArrayType = { company: comp, sites: site };
          }
          arr.push(dataArray);

        }
        this.dataSource = new MatTableDataSource(arr);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      });

    }
  }

  toggleChanged: boolean = false;
  sidebarOpen: boolean = false;

  toggleNav() {
    console.log(this.toggleChanged);
    this.toggleChanged = !this.toggleChanged;
    this.sidebarOpen = !this.sidebarOpen;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }


  exportUnapprovedSources() {

    arr = [];

    this.http.get(this.baseURL + 'api/UnapprovedSources/GetUnapprovedSource').subscribe(data => {
      var keys = Object.keys(data);
      var len = keys.length;

      for (var i = 0; i <= len - 1; i++) {
        var comp = data[i]["company"];
        var site = data[i]["sites"];

        if (comp != "") {
          var dataArray: MyArrayType = { company: comp, sites: site };
        }
        else {
          var dataArray: MyArrayType = { company: comp, sites: site };
        }
        arr.push(dataArray);

      }
      var d = new Date();
      var n = this.formatDate(d);

      let fileName = 'UnapprovedSources_' + n;
      let sheetName = "UnapprovedSources";

      var wb = XLSX.utils.book_new();
      var ws = XLSX.utils.json_to_sheet(arr);
      XLSX.utils.book_append_sheet(wb, ws, sheetName);
      XLSX.writeFile(wb, `${fileName}.xlsx`);
    });
  }

  formatDate(date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;

    return [year, month, day].join('-');
  }
}
